import React, { useRef, useState } from "react";
import {
  Accordion,
  Col,
  Container,
  Form,
  Overlay,
  Row,
  Tooltip,
} from "react-bootstrap";
import notification from "../assets/images/notification.svg";
import schedular from "../assets/images/schedular.svg";
import dollar from "../assets/images/dollar.svg";
import searchicon from "../assets/images/searchicon.svg";
import infobtn from "../assets/images/infobtnblue.svg";
import hotel from "../assets/images/hotel.svg";
import blueadd from "../assets/images/blueadd.svg";
import sql from "../assets/images/sql.svg";
import mysql from "../assets/images/mysql.svg";
import postgre from "../assets/images/postgre.svg";
import greenCheckbox from "../assets/images/green-checkbox.svg";
import AnnualSummary from "../assets/images/annual-summary.svg";
import forecast from "../assets/images/forecast.svg";
import transgroup from "../assets/images/trans-group.svg";
import heatmap from "../assets/images/heatmap.svg";
import dailySummary from "../assets/images/daily-summary.svg";
import bookingpace from "../assets/images/booking-pace.svg";
import reservation from "../assets/images/reservation.svg";
import pickup from "../assets/images/pickup.svg";
import strategy from "../assets/images/strategy.svg";
import marketsegment from "../assets/images/market-segment.svg";
import marketsegmentdrilldown from "../assets/images/marketsegmentdrilldown.svg";
import rateplan from "../assets/images/rateplans.svg";
import los from "../assets/images/lengthofstay.svg";
import roomtype from "../assets/images/roomtype.svg";
import grpandevent from "../assets/images/groupandevent.svg";
import lyandforecast from "../assets/images/lyandforecast.svg";
import str from "../assets/images/str.svg";
import segmentdrilldown from "../assets/images/segmentdrilldown.svg";
import accounts from "../assets/images/accounts.svg";
import copyIcon from "../assets/images/copyIcon.svg";
import Select from "react-select";
import { Link } from "react-router-dom";
import PasswordLocker from "./common-component/PasswordLocker";
import CostAndUsagePopup from "./common-component/CostAndUsagePopup";
import NotificationPopup from "./common-component/NotificationPopup";
import SchedularPopup from "./common-component/SchedularPopup";
import ReportInfoPopup from "./common-component/ReportInfoPopup";
import CostSummarySection from "./common-component/CostSummarySection";
import UpcomingSchedules from "./common-component/UpcomingSchedules";

function ProjectView() {
  const options = [
    { value: "johnkennedy12@gmail.com", label: "johnkennedy12@gmail.com" },
    { value: "sarahjohnson1@gmail.com", label: "sarahjohnson1@gmail.com" },
    { value: "emilawatson@gmail.com", label: "emilawatson@gmail.com" },
    { value: "johnkennedy121@gmail.com", label: "johnkennedy121@gmail.com" },
    { value: "sarahjohnson111@gmail.com", label: "sarahjohnson111@gmail.com" },
    { value: "emilawatson11@gmail.com", label: "emilawatson11@gmail.com" },
  ];

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleshowPopup = (e, modalName) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowPassword(modalName);
  };
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState("");
  const [showAnnualSummary, setShowAnnualSummary] = useState("");
  const target = useRef(null);
  const notification1 = useRef(null);
  const target1 = useRef(null);
  const project = useRef(null);
  const dbconnection = useRef(null);
  const bi = useRef(null);
  const pmsconnection = useRef(null);
  const output = useRef(null);
  const annualSummary = useRef(null);
  const activeRef = useRef(null);

  const [showNotification, setShowNotification] = useState(false);

  const handleshowNotification = () => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowNotification(!showNotification);
  };
  const handleAnnualSummary = () => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowAnnualSummary(!showAnnualSummary);
  };
  const handleshowCostPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    // setShowCostPopup(!showCostPopup);
    setShow(!show);
  };

  const [outputSelection, setOutputSelection] = useState("");

  const handleOutputRadiochange = (event) => {
    // setIsApiChecked(event.target.checked);
    setOutputSelection(event);
  };
  const [apiBodyShow, setApiBodyShow] = useState(false);
  const handleApiBody = () => {
    setApiBodyShow(!apiBodyShow);
  };

  const handleSnapshotClick = (event) => {
    event.currentTarget.classList.add("active");
    activeRef.current = event.currentTarget;
  };
  const textareaRef = useRef(null);

  const handleCopyClick = () => {
    if (textareaRef.current) {
      textareaRef.current.select();
      document.execCommand("copy");
     
    }
  };

  const [showSchedularPopup, setShowSchedularPopup] = useState(false);

  const handleshowSchedularPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSchedularPopup(!showSchedularPopup);
  };

  const targetSchedular = useRef(null);
  return (
    <div className="projects-view-page-main having-small-blue-bg">
      <Container>
        <div className="top-bot-section">
          <h6>Project View</h6>
          <div className="top-bot-right-section">
            <div
              className="filtering-main"
              id="notification-main-one"
              onClick={(e) => {
                e.preventDefault();
                handleOverlay(e);
                setShowNotification(!showNotification);
                handleshowNotification();
              }}
              ref={notification1}
            >
              <img src={notification} alt="notification" />
              <span>Notifications</span>
            </div>
            <div
              className="filtering-main"
              id="scheduler-one"
              onClick={(e) => {
                e.preventDefault();
                handleOverlay(e);
                setShowSchedularPopup(!showSchedularPopup);
                handleshowSchedularPopup();
              }}
              ref={targetSchedular}
            >
              <img src={schedular} alt="schedular" />
              <span>Scheduler</span>
            </div>
            <div
              className="filtering-main"
              id="cost-usage-one"
              onClick={(e) => {
                e.preventDefault();
                handleOverlay(e);
                setShow(!show);
                handleshowCostPopup(e);
              }}
              ref={target}
            >
              <img src={dollar} alt="dollar" />
              <span>Cost & Usage</span>
            </div>
            {show && (
              <Overlay
                target={target.current}
                show={show}
                placement="bottom-end"
              >
                {(props) => (
                  <Tooltip id="overlay-example" {...props}>
                    <CostAndUsagePopup handleshowPopup={handleshowCostPopup} />
                  </Tooltip>
                )}
              </Overlay>
            )}
            {showNotification && (
              <Overlay
                target={notification1.current}
                show={showNotification}
                placement="bottom-end"
              >
                {(props) => (
                  <Tooltip id="overlay-example" {...props}>
                    <NotificationPopup closePopup={handleshowNotification} />
                  </Tooltip>
                )}
              </Overlay>
            )}
            {showSchedularPopup && (
              <Overlay
                target={targetSchedular.current}
                show={handleshowSchedularPopup}
                placement="bottom"
              >
                {(props) => (
                  <Tooltip id="overlay-example" {...props}>
                    <SchedularPopup
                      handleshowPopup={handleshowSchedularPopup}
                    />
                  </Tooltip>
                )}
              </Overlay>
            )}
          </div>
        </div>
      </Container>
      <div className="main-page-content">
        <Container>
          <div className="project-view-detail common-white-bg">
            <Row>
              <Col xl={7}>
                <Accordion
                  defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                  alwaysOpen
                  className="common-accordion"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <span>Project</span>
                    </Accordion.Header>
                    <span
                      className="info-btn-absolute"
                      id="project"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        handleshowPopup(e, "project");
                      }}
                      ref={project}
                    >
                      <img src={infobtn} alt="infobtn" />
                    </span>
                    {showPassword === "project" && (
                      <Overlay
                        target={project.current}
                        show={showPassword}
                        placement="right"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <PasswordLocker
                              accordionPopupTitle="Project"
                              handleshowPopup={handleshowPopup}
                              accordionBody="Please provide the name of your project in this input field. The project name is a crucial identifier that will be used throughout the development process and in all related documentation. A well-chosen project name should be concise, descriptive, and reflective of the project's main objectives or features. Avoid overly generic names to ensure clarity and distinction from other projects. A good project name facilitates better communication among team members, stakeholders, and users. It can also enhance the project's visibility and branding. Think of a name that encapsulates the essence of your software solution and its intended impact. Once set, this name will appear in project dashboards, reports, and all relevant communications, so choose thoughtfully."
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    )}

                    <Accordion.Body>
                      <p className="common-accordion-para">
                        Please provide the name of your project. This name will
                        be used to identify and reference your project
                        throughout its lifecycle. Choose a concise and
                        descriptive name that reflects the purpose or main
                        feature of your project.
                      </p>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label className="common-label">
                              Project Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Choice"
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <span>Password Locker</span>
                    </Accordion.Header>
                    <span
                      className="info-btn-absolute"
                      id="password-locker"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        handleshowPopup(e, "passwordLocker");
                      }}
                      ref={target1}
                    >
                      <img src={infobtn} alt="infobtn" />
                    </span>
                    {showPassword === "passwordLocker" ? (
                      <Overlay
                        target={target1.current}
                        show={showPassword === "passwordLocker"}
                        placement="right"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <PasswordLocker
                              accordionPopupTitle="Password Locker"
                              handleshowPopup={handleshowPopup}
                              accordionBody="Enter a secure and memorable password for your Password Locker. This password will safeguard all your stored credentials and sensitive information, so it's crucial to choose a strong and unique password. A strong password typically includes a mix of uppercase and lowercase letters, numbers, and special characters, and is at least 8-12 characters long. Avoid using easily guessable information such as common words, names, or sequences. Remember that the security of your Password Locker depends heavily on the strength of this password, so take the time to create one that is robust. "
                              accordionBody2="If needed, consider using a passphrase or a combination of unrelated words for added security. Ensure you store this password securely, as it will be essential for accessing your protected information. Regularly updating your password can further enhance security."
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    ) : (
                      ""
                    )}
                    <Accordion.Body>
                      <p className="common-accordion-para">
                        Enter a secure and memorable password for your Password
                        Locker. This password will protect your stored
                        credentials and sensitive information. Ensure it is
                        strong by using a combination of letters, numbers, and
                        special characters.
                      </p>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label className="common-label">
                              User Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="User Name"
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label className="common-label">
                              Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              placeholder="******"
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <span>PMS Connection</span>
                    </Accordion.Header>
                    <span
                      className="info-btn-absolute"
                      id="pms-connection"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        // setShowPassword(!showPassword);
                        handleshowPopup(e, "pmsConnection");
                      }}
                      ref={pmsconnection}
                    >
                      <img src={infobtn} alt="infobtn" />
                    </span>
                    {showPassword === "pmsConnection" && (
                      <Overlay
                        target={pmsconnection.current}
                        show={showPassword}
                        placement="right"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <PasswordLocker
                              accordionPopupTitle="PMS Connection"
                              handleshowPopup={handleshowPopup}
                              accordionBody="The PMS Connection feature allows you to integrate and synchronize our application with various Property Management Systems (PMS) seamlessly. PMS is a software solution used in the hospitality industry to manage reservations, check-ins, check-outs, billing, and other operational tasks. There are several types of PMS that you might encounter, each with unique features and integration methods."
                              accordionBody2="On-premise PMS These are installed locally on the property’s hardware. Connecting to on-premise PMS typically involves using APIs provided by the PMS vendor. You may need to configure firewall settings and ensure network security for seamless data exchange."
                              accordionsemititle="Cloud-based PMS:"
                              accordionsemicontent="These systems are hosted on remote servers and accessed via the internet. Integration with cloud-based PMS often requires API keys or OAuth tokens for secure data access. Ensure that you have proper authentication and encryption in place for secure communication."
                              accordionsemititle1="Hybrid PMS:"
                              accordionsemicontent1="These systems combine both on-premise and cloud-based features. Connecting to a hybrid PMS might require a combination of local network configurations and cloud-based API integrations."
                              accordionsemititle2="Open-source PMS:"
                              accordionsemicontent2="These are customizable systems where the source code is available for modification. Integration with open-source PMS can be highly flexible, but may require additional development work to align with the specific API standards and protocols used by the system."
                              smallPara="To connect with these different types of PMS, follow these general steps:"
                              listitems={[
                                "Obtain the necessary API documentation and access credentials from your PMS provider.",
                                "Configure your application to use the provided API endpoints for data exchange.",
                                "Ensure that all communication is encrypted using SSL/TLS protocols to protect sensitive data.",
                                "Set up automated synchronization to keep the data between your application and the PMS up-to-date in real time.",
                                "Test the connection thoroughly to ensure that all data transfers are accurate and reliable.",
                                "By integrating with various PMS, you can streamline operations, improve efficiency, and provide a seamless experience for your users. Always refer to the specific integration guidelines provided by your PMS vendor for the best results.",
                              ]}
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    )}
                    <Accordion.Body>
                      <p className="common-accordion-para">
                        The PMS Connection feature allows you to integrate and
                        synchronize our application with various Property
                        Management Systems (PMS) seamlessly. PMS is a software
                        solution used in the hospitality industry to manage
                        reservations, check-ins, check-outs, billing, and other
                        operational tasks. There are several types of PMS that
                        you might encounter, each with unique features and
                        integration methods.
                      </p>
                      <div className="select-property-main">
                        <div className="select-property-single active">
                          <img src={hotel} alt="hotel" />
                          <h6>Choice</h6>
                          <p className="report-price">$17.00</p>
                        </div>
                        <div className="select-property-single">
                          <img src={hotel} alt="hotel" />
                          <h6>Opera</h6>
                          <p className="report-price">$18.00</p>
                        </div>
                        <div className="select-property-single">
                          <img src={hotel} alt="hotel" />
                          <h6>Red Roof</h6>
                          <p className="report-price">$16.00</p>
                        </div>
                      </div>
                      <Accordion
                        defaultActiveKey="0"
                        className="child-accordion"
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>Property 1</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Property ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="PR32701"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Client ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group mt20">
                                  <Form.Label className="common-label">
                                    Property Code
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="AC32AW"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Secret
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group   mt20">
                                  <Form.Label className="common-label">
                                    Reservation Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="2 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group   mt20">
                                  <Form.Label className="common-label">
                                    Reservation After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group   mt20">
                                  <Form.Label className="common-label">
                                    Occupancy Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group   mt20">
                                  <Form.Label className="common-label">
                                    Occupancy After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>Property 2</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Property ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="PR32701"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Client ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Code
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="AC32AW"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Secret
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Reservation Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="2 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Reservation After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Occupancy Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Occupancy After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                          <Accordion.Header>Property 3</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Property ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="PR32701"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Client ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Code
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="AC32AW"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Secret
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Reservation Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="2 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Reservation After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Occupancy Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Occupancy After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                          <Accordion.Header>Property 4</Accordion.Header>
                          <Accordion.Body>
                            <Row>
                              <Col sm={6}>
                                <Form.Group className="form-group ">
                                  <Form.Label className="common-label">
                                    Property ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="PR32701"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Client ID
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Code
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="AC32AW"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={6}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Property Secret
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="-"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Reservation Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="2 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Reservation After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Occupancy Before
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={3}>
                                <Form.Group className="form-group  mt20">
                                  <Form.Label className="common-label">
                                    Occupancy After
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="4 Days"
                                    className="common-input"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <div className="add-property">
                        <img src={blueadd} alt="blueadd" />
                        <p>Add Property</p>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="3"
                    className="different-bg-accordion-item"
                  >
                    <Accordion.Header>
                      <span>Database Connection</span>
                    </Accordion.Header>
                    <span
                      className="info-btn-absolute"
                      id="db-connection"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        // setShowPassword(!showPassword);
                        handleshowPopup(e, "databaseConnection");
                      }}
                      ref={dbconnection}
                    >
                      <img src={infobtn} alt="infobtn" />
                    </span>
                    {showPassword === "databaseConnection" && (
                      <Overlay
                        target={dbconnection.current}
                        show={showPassword}
                        placement="right"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <PasswordLocker
                              accordionPopupTitle="Database Connection"
                              handleshowPopup={handleshowPopup}
                              accordionBody="The Database Connection feature allows you to integrate our application with various types of databases, enabling seamless data management and retrieval. Different databases serve different purposes and have unique connection methods. Here’s an overview of the main types of databases and how to connect with them:"
                              accordionBody2="If needed, consider using a passphrase or a combination of unrelated words for added security. Ensure you store this password securely, as it will be essential for accessing your protected information. Regularly updating your password can further enhance security."
                              accordionsemititle="Relational Databases (RDBMS):"
                              accordionsemicontent="These databases, such as MySQL, PostgreSQL, Oracle, and SQL Server, use structured query language (SQL) to manage data. To connect to an RDBMS, you typically use a database driver (e.g., JDBC, ODBC) that matches your programming language. You'll need to specify the database URL, username, and password in your connection string."
                              accordionsemititle1="NoSQL Databases:"
                              accordionsemicontent1="These include MongoDB, Cassandra, and CouchDB, which are designed for handling unstructured data. Connections to NoSQL databases often use specific drivers or libraries provided by the database vendors. For instance, MongoDB uses the MongoDB driver, which requires specifying the connection URI and authentication details."
                              accordionsemititle2="In-memory Databases:"
                              accordionsemicontent2=" Examples include Redis and Memcached, which store data in memory for fast access. Connecting to in-memory databases typically involves using client libraries that allow you to configure the server address, port, and authentication parameters."
                              accordionsemititle3="NewSQL Databases:"
                              accordionsemicontent3="These databases, such as CockroachDB and Google Spanner, combine the scalability of NoSQL with the ACID guarantees of traditional RDBMS. Connections are often similar to RDBMS, using SQL-like interfaces and requiring the appropriate drivers and connection details."
                              smallPara="To connect with these different types of databases, follow these general steps:"
                              listitems={[
                                "Configure the connection string:  This typically includes the database server address, port, database name, username, and password.",
                                "Test the connection: Validate the connection settings by running test queries to ensure data can be accessed and manipulated as expected.",
                                "By integrating with various types of databases, you can ensure your application can handle diverse data storage requirements efficiently. Always refer to the specific integration guidelines provided by your database vendor for the best results.",
                              ]}
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    )}
                    <Accordion.Body>
                      <p className="common-accordion-para">
                        The Database Connection feature allows you to integrate
                        our application with various types of databases,
                        enabling seamless data management and retrieval.
                        Different databases serve different purposes and have
                        unique connection methods. Here’s an overview of the
                        main types of databases and how to connect with them:
                      </p>
                      <div className="select-property-main">
                        <div className="select-property-single active">
                          <img src={sql} alt="sql" />
                          <h6>My SQL</h6>
                          <p className="report-price">$7.00</p>
                        </div>
                        <div className="select-property-single">
                          <img src={postgre} alt="postgre" />
                          <h6>Postgre SQL</h6>
                          <p className="report-price">$7.00</p>
                        </div>
                        <div className="select-property-single">
                          <img src={mysql} alt="mysql" />
                          <h6>MS SQL</h6>
                          <p className="report-price">$7.00</p>
                        </div>
                      </div>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label className="common-label">
                              Hostname
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="spo.cboo2sigorli.ap-south-1.rds.am..."
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label className="common-label">
                              Database Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="choice"
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group   mt20">
                            <Form.Label className="common-label">
                              User
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="admin"
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group mt20">
                            <Form.Label className="common-label">
                              Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              placeholder="******"
                              className="common-input"
                            />
                          </Form.Group>
                        </Col>
                        <Col xl={12} className="text-end mt20">
                          <button className="blue-btn w-auto">
                            Test Connection
                          </button>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <span>Business Intelligence</span>
                    </Accordion.Header>
                    <span
                      className="info-btn-absolute"
                      id="bi"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        // setShowPassword(!showPassword);
                        handleshowPopup(e, "bi");
                      }}
                      ref={bi}
                    >
                      <img src={infobtn} alt="infobtn" />
                    </span>
                    {showPassword === "bi" && (
                      <Overlay
                        target={bi.current}
                        show={showPassword}
                        placement="right"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <PasswordLocker
                              accordionPopupTitle="Business Intelligence"
                              handleshowPopup={handleshowPopup}
                              accordionBody="The Business Insights feature in our Hotel Revenue Management System provides a powerful toolset for analyzing and optimizing various aspects of your hotel’s performance. This feature offers options to choose from different types of insights, enabling you to maximize revenue, enhance guest satisfaction, and streamline operations."
                              accordionsemititle="Revenue Insights:"
                              accordionsemicontent="Analyze room rates, occupancy levels, and revenue per available room (RevPAR) to identify trends and opportunities for maximizing revenue. Use these insights to adjust pricing strategies and optimize revenue management."
                              accordionsemititle1="Booking Insights:"
                              accordionsemicontent1="Understand booking patterns, lead times, and distribution channel performance. These insights help you tailor your marketing efforts and improve your booking strategies across different platforms."
                              accordionsemititle2="Guest Insights: "
                              accordionsemicontent2="Gain insights into guest demographics, preferences, and feedback. These insights assist in personalizing guest experiences, improving satisfaction, and fostering loyalty."
                              accordionsemititle3="Financial Insights: "
                              accordionsemicontent3="Examine financial metrics such as operating costs, profit margins, and cash flow. Use these insights for budgeting, financial planning, and identifying areas for cost reduction."
                              accordionsemititle4="Operational Insights:"
                              accordionsemicontent4="Evaluate the efficiency of hotel operations, including housekeeping, front desk services, and maintenance. Use these insights to streamline processes and enhance service quality."
                              accordionsemititle5="Marketing Insights:"
                              accordionsemicontent5="Measure the effectiveness of marketing campaigns, promotions, and special offers. Understand which campaigns drive the most bookings and guest engagement to optimize your marketing spend."
                              accordionsemititle6="Competitor Insights: "
                              accordionsemicontent6="Monitor competitor performance, pricing strategies, and market positioning. Use these insights to adjust your strategies and stay competitive in the market."
                              smallPara="To utilize the Business Insights feature, follow these steps:"
                              listitems={[
                                "Select the type of insight you need:  Choose from revenue, booking, guest, financial, operational, marketing, or competitor insights based on your current objectives.",
                                "Customize your insights:  Set parameters and filters to tailor the insights to your specific hotel and market conditions.Generate reports and dashboards: Visualize the insights through customizable reports and interactive dashboards for easy interpretation and decision-making.",
                                "Analyze and act: Use the generated insights to make informed decisions, implement strategies that drive revenue growth, improve guest experiences, and enhance operational efficiency.",
                                "By leveraging the Business Insights feature, you can gain a comprehensive understanding of your hotel’s performance and uncover valuable opportunities for improvement and growth.",
                              ]}
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    )}
                    <Accordion.Body>
                      <p className="common-accordion-para">
                        The Business Insights feature in our Hotel Revenue
                        Management System provides a powerful toolset for
                        analyzing and optimizing various aspects of your hotel’s
                        performance. This feature offers options to choose from
                        different types of insights, enabling you to maximize
                        revenue, enhance guest satisfaction, and streamline
                        operations.
                      </p>
                      <Accordion
                        defaultActiveKey="0"
                        className="child-accordion"
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <span>Snapshot </span>
                            <span className="theme-color-text selected-bi">
                              Selected{" "}
                              <span className="blue-badge theme-color-text">
                                1
                              </span>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="common-accordion-para">
                              Snapshots Business Insights provides a quick,
                              comprehensive overview of key performance metrics
                              and trends for your hotel. Instantly visualize
                              crucial data points like revenue, occupancy rates,
                              and guest satisfaction to make informed decisions
                              and optimize operations.
                            </p>
                            <div className="all-snapshot-here">
                              <div className="select-property-main snapshot-slider ">
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={AnnualSummary}
                                    alt="annualSummary"
                                  />
                                  <h6>Annual Summary</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                    id="annualSummary"
                                    ref={annualSummary}
                                    onClick={handleAnnualSummary}
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                {annualSummary && (
                                  <Overlay
                                    target={annualSummary.current}
                                    show={showAnnualSummary}
                                    placement="right"
                                  >
                                    {(props) => (
                                      <Tooltip id="overlay-example" {...props}>
                                        <ReportInfoPopup
                                          handleshowPopup={handleAnnualSummary}
                                        />
                                      </Tooltip>
                                    )}
                                  </Overlay>
                                )}
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={forecast} alt="forecast" />
                                  <h6>Forecast</h6>
                                  <p className="report-price">$9.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={pickup} alt="pickup" />
                                  <h6>Pick Up</h6>
                                  <p className="report-price">$6.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={transgroup} alt="transgroup" />
                                  <h6>Transient Group</h6>
                                  <p className="report-price">$5.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={dailySummary} alt="dailySummary" />
                                  <h6>Daily Summary</h6>
                                  <p className="report-price">$9.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={bookingpace} alt="bookingpace" />
                                  <h6>Booking Pace YOY</h6>
                                  <p className="report-price">$8.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={heatmap} alt="heatmap" />
                                  <h6>Heatmap</h6>
                                  <p className="report-price">$4.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={reservation} alt="reservation" />
                                  <h6>Reservation Activity</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="search-from-snapshot">
                                <img src={searchicon} alt="searchicon" />
                                <Link to="/marketplace">
                                  Browse more from Marketplace
                                </Link>
                                <p>
                                  Including widgets from market place and
                                  community
                                </p>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            <span>Day By Day </span>
                            <span className="theme-color-text selected-bi">
                              Selected{" "}
                              <span className="blue-badge theme-color-text">
                                3
                              </span>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="common-accordion-para">
                              Day-by-Day Business Insights offers detailed daily
                              analysis of revenue, occupancy, and booking trends
                              within your hotel. This feature allows you to
                              track performance fluctuations over time, enabling
                              proactive adjustments to pricing strategies and
                              operational decisions.
                            </p>
                            <div className="all-snapshot-here">
                              <div className="select-property-main snapshot-slider">
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={strategy} alt="strategy" />
                                  <h6>Strategy</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={marketsegment}
                                    alt="marketsegment"
                                  />
                                  <h6>Market Segment</h6>
                                  <p className="report-price">$5.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={rateplan} alt="rateplan" />
                                  <h6>Rate Plans</h6>
                                  <p className="report-price">$6.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={los} alt="los" />
                                  <h6>Length Of Stay</h6>
                                  <p className="report-price">$9.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={roomtype} alt="roomtype" />
                                  <h6>Room Type</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={grpandevent} alt="grpandevent" />
                                  <h6>Group & Events</h6>
                                  <p className="report-price">$5.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={lyandforecast}
                                    alt="lyandforecast"
                                  />
                                  <h6>Last year & Forecast</h6>
                                  <p className="report-price">$5.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={str} alt="str" />
                                  <h6>STR</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="search-from-snapshot">
                                <img src={searchicon} alt="searchicon" />
                                <Link to="/marketplace">
                                  Browse more from Marketplace
                                </Link>
                                <p>
                                  Including widgets from market place and
                                  community
                                </p>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                          <Accordion.Header>
                            <span>Segment Drilldown </span>
                            <span className="theme-color-text selected-bi">
                              Selected{" "}
                              <span className="blue-badge theme-color-text">
                                1
                              </span>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="common-accordion-para">
                              Segment Drilldown allows detailed analysis of
                              specific guest segments or market demographics
                              within your hotel's performance data. Identify
                              trends, preferences, and behaviors among different
                              guest groups to tailor marketing strategies and
                              improve guest experiences effectively.
                            </p>
                            <div className="all-snapshot-here">
                              <div className="select-property-main snapshot-slider">
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={segmentdrilldown}
                                    alt="segmentdrilldown"
                                  />
                                  <h6>Segment Drilldown</h6>
                                  <p className="report-price">$8.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={marketsegmentdrilldown}
                                    alt="marketsegmentdrilldown"
                                  />
                                  <h6 title="Market Segment Drilldown">
                                    Market Segment...
                                  </h6>
                                  <p className="report-price">$10.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="search-from-snapshot">
                                <img src={searchicon} alt="searchicon" />
                                <Link to="/marketplace">
                                  Browse more from Marketplace
                                </Link>
                                <p>
                                  Including widgets from market place and
                                  community
                                </p>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                          <Accordion.Header>
                            <span>Accounts </span>
                            <span className="theme-color-text selected-bi">
                              Selected{" "}
                              <span className="blue-badge theme-color-text">
                                0
                              </span>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="common-accordion-para">
                              Accounts feature provides detailed financial
                              tracking and management capabilities within the
                              Hotel Revenue Management System. It allows you to
                              monitor revenue streams, expenses, and
                              profitability accurately, facilitating strategic
                              financial planning and decision-making.
                            </p>
                            <div className="all-snapshot-here">
                              <div className="select-property-main snapshot-slider">
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={accounts} alt="accounts" />
                                  <h6>Accounts</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="search-from-snapshot">
                                <img src={searchicon} alt="searchicon" />
                                <Link to="/marketplace">
                                  Browse more from Marketplace
                                </Link>
                                <p>
                                  Including widgets from market place and
                                  community
                                </p>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                          <Accordion.Header>
                            <span>RevPAK </span>
                            <span className="theme-color-text selected-bi">
                              Selected{" "}
                              <span className="blue-badge theme-color-text">
                                4
                              </span>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="common-accordion-para">
                              RevPAK is a powerful revenue performance analysis
                              tool within the Hotel Revenue Management System.
                              It offers comprehensive insights into Revenue per
                              Available Key (RevPAK), helping hotels optimize
                              pricing strategies and maximize profitability by
                              analyzing revenue generated per available key or
                              room.
                            </p>
                            <div className="all-snapshot-here">
                              <div className="select-property-main snapshot-slider">
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={annualSummary}
                                    alt="annualSummary"
                                  />
                                  <h6>Annual Summary</h6>
                                  <p className="report-price">$6.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                    onClick={handleAnnualSummary}
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={pickup} alt="pickup" />
                                  <h6>Pick Up</h6>
                                  <p className="report-price">$5.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img
                                    src={marketsegment}
                                    alt="marketsegment"
                                  />
                                  <h6>90 Day Segment</h6>
                                  <p className="report-price">$4.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={dailySummary} alt="dailySummary" />
                                  <h6>Daily Summary</h6>
                                  <p className="report-price">$8.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={str} alt="str" />
                                  <h6>STR Analysis</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={str} alt="str" />
                                  <h6>RevPAK Summary</h6>
                                  <p className="report-price">$5.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="search-from-snapshot">
                                <img src={searchicon} alt="searchicon" />
                                <Link to="/marketplace">
                                  Browse more from Marketplace
                                </Link>
                                <p>
                                  Including widgets from market place and
                                  community
                                </p>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5">
                          <Accordion.Header>
                            <span>Reports </span>
                            <span className="theme-color-text selected-bi">
                              Selected{" "}
                              <span className="blue-badge theme-color-text">
                                2
                              </span>
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="common-accordion-para">
                              Reports in the context of a Hotel Revenue
                              Management System provide detailed analyses and
                              summaries of key performance indicators such as
                              occupancy rates, revenue trends, and guest
                              demographics. These insights enable informed
                              decision-making and strategic planning to optimize
                              operational efficiency and maximize revenue.
                            </p>
                            <div className="all-snapshot-here">
                              <div className="select-property-main snapshot-slider">
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={accounts} alt="accounts" />
                                  <h6>Daily Snapshot</h6>
                                  <p className="report-price">$7.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={accounts} alt="accounts" />
                                  <h6>Weekly Snapshot</h6>
                                  <p className="report-price">$10.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="select-property-single active"
                                  onClick={handleSnapshotClick}
                                >
                                  <img src={accounts} alt="accounts" />
                                  <h6>Monthly Snapshot</h6>
                                  <p className="report-price">$3.00</p>
                                  <img
                                    src={infobtn}
                                    alt="infobtn"
                                    className="infobtn-single"
                                  />
                                  <div className="green-checkbox">
                                    <img
                                      src={greenCheckbox}
                                      alt="green-checkbox"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="search-from-snapshot">
                                <img src={searchicon} alt="searchicon" />
                                <Link to="/marketplace">
                                  Browse more from Marketplace
                                </Link>
                                <p>
                                  Including widgets from market place and
                                  community
                                </p>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      <span>Output</span>
                    </Accordion.Header>
                    <span
                      className="info-btn-absolute"
                      id="output"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        // setShowPassword(!showPassword);
                        handleshowPopup(e, "output");
                      }}
                      ref={output}
                    >
                      <img src={infobtn} alt="infobtn" />
                    </span>
                    {showPassword === "output" && (
                      <Overlay
                        target={output.current}
                        show={showPassword}
                        placement="right"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <PasswordLocker
                              accordionPopupTitle="Output"
                              handleshowPopup={handleshowPopup}
                              accordionBody=" Our system offers versatile output options tailored to meet diverse customer needs."
                              accordionsemititle="Emails:"
                              accordionsemicontent="Deliver reports and notifications directly to stakeholders' inboxes, ensuring timely updates on key metrics like occupancy rates or revenue trends. Customize email templates to include relevant insights and actionable data, enhancing communication efficiency."
                              accordionsemititle1="API Integration: "
                              accordionsemicontent1="Enable seamless data exchange with other systems or applications through APIs. Customers can integrate our reports and analytics into their existing dashboards or business intelligence tools, facilitating comprehensive data analysis and decision-making."
                              accordionsemititle2="Embedded HTML: "
                              accordionsemicontent2="Embed interactive reports and visuals directly into customer portals or websites using HTML integration. This provides real-time access to dynamic data visualizations, empowering users to monitor performance metrics effortlessly."
                              accordionsemititle3="WebHook Notifications: "
                              accordionsemicontent3="Configure WebHooks to trigger notifications and updates in external systems based on specific events or thresholds. This ensures proactive alerting for critical changes, such as sudden booking spikes or revenue drops, enabling prompt responses."
                              bigPara="Each output method is customizable to align with customer preferences and operational workflows, ensuring seamless integration and actionable insights. Whether it's real-time API data feeds for continuous monitoring or scheduled email reports for regular updates, our flexible outputs empower businesses to leverage data effectively for strategic decision-making and operational excellence."
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    )}
                    <Accordion.Body>
                      <p className="common-accordion-para">
                        Our system offers versatile output options tailored to
                        meet diverse customer needs.
                      </p>
                      <Row>
                        <Col xl={12}>
                          <Form.Label className="common-label">
                            <b>Export Snapshots (4) as:</b>
                          </Form.Label>
                        </Col>
                        <Col xl={12}>
                          <div className="radio-title">
                            <div className="d-flex flex-column gap-2 mt12 mb-4">
                              <Form.Check
                                type="radio"
                                id="default-radio1"
                                label="RevEvolve Portal"
                                name="output"
                              />
                              <Form.Check
                                type="radio"
                                id="default-radio1"
                                label="Email"
                                name="output"
                                checked={
                                  outputSelection === "email" ? true : false
                                }
                                onChange={() => {
                                  handleOutputRadiochange("email");
                                }}
                              />
                              {outputSelection === "email" && (
                                <div className="mb-2">
                                  <Select
                                    defaultValue={[options[2], options[3]]}
                                    isMulti
                                    name="colors"
                                    options={options}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                  />
                                  <div className="radio-title small-radio mt-2">
                                    <div className="d-flex align-items-center gap-4 ps-3">
                                      <Form.Check
                                        type="radio"
                                        id="default-radio"
                                        label="Excel"
                                        name="via"
                                      />
                                      <Form.Check
                                        type="radio"
                                        id="default-radio"
                                        label="CSV"
                                        name="via"
                                      />
                                      <Form.Check
                                        type="radio"
                                        id="default-radio"
                                        label="PDF"
                                        name="via"
                                      />
                                    </div>
                                  </div>
                                  <p className="criteria-text">
                                    Customize email templates to include
                                    relevant insights and actionable data,
                                    enhancing communication efficiency.
                                  </p>
                                </div>
                              )}
                              <Form.Check
                                type="radio"
                                id="default-radio3"
                                label="API"
                                name="output"
                                checked={
                                  outputSelection === "api" ? true : false
                                }
                                onChange={() => {
                                  handleOutputRadiochange("api");
                                }}
                              />
                              {outputSelection === "api" && (
                                <>
                                  <div className="api-section-main">
                                    <div
                                      className="api-title cursor-pointer"
                                      onClick={handleApiBody}
                                    >
                                      <span className="blue-badge">POST</span>
                                      <p>/api/widget/mst_reservation</p>
                                    </div>
                                    {apiBodyShow ? (
                                      <div className="api-body">
                                        <div className="api-parameter">
                                          <h6>Parameters</h6>
                                        </div>
                                        <div className="no-parameter">
                                          <p>No parameters</p>
                                        </div>
                                        <div className="request-body">
                                          <div className="request-body-top">
                                            <h6>Request body</h6>
                                            <h6>Application / Json</h6>
                                          </div>
                                          <div className="request-body-inner">
                                            <div className="d-flex align-items-center">
                                              <span>
                                                <b>Example Value</b>
                                              </span>
                                            </div>
                                            <div className="black-response">
                                              <p>{"{"}</p>
                                              <div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"ProjectID":</p>
                                                  <p>
                                                    "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                                                    ,
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Components":</p>
                                                  <p>
                                                    "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                                                    ,
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Last Update":</p>
                                                  <p>
                                                    "2024-06-17T10:34:38.071Z",
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Next Schedule":</p>
                                                  <p>
                                                    "2024-06-17T10:34:38.071Z" ,
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Status":</p>
                                                  <p>"string" ,</p>
                                                </div>
                                              </div>
                                              <p>{"}"}</p>
                                            </div>
                                          </div>
                                          <div className="response-body">
                                            <h6>
                                              <b>Response</b>
                                            </h6>
                                            <div className="black-response">
                                              <>
                                                <p>{"{"}</p>
                                                <div>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <p>"ProjectID":</p>
                                                    <p>
                                                      "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                                                      ,
                                                    </p>
                                                  </div>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <p>" Components":</p>
                                                    <p>
                                                      "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                                                      ,
                                                    </p>
                                                  </div>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <p>"Last Update":</p>
                                                    <p>
                                                      "2024-06-17T10:34:38.071Z",
                                                    </p>
                                                  </div>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <p>"Next Schedule":</p>
                                                    <p>
                                                      "2024-06-17T10:34:38.071Z"
                                                      ,
                                                    </p>
                                                  </div>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <p>"Status":</p>
                                                    <p>"string" ,</p>
                                                  </div>
                                                </div>
                                                <p>{"}"}</p>
                                              </>
                                              <>
                                                <p>{"{"}</p>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"ProjectID":</p>
                                                  <p>
                                                    "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                                                    ,
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>" Components":</p>
                                                  <p>
                                                    "3fa85f64-5717-4562-b3fc-2c963f66afa6"
                                                    ,
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Last Update":</p>
                                                  <p>
                                                    "2024-06-17T10:34:38.071Z",
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Next Schedule":</p>
                                                  <p>
                                                    "2024-06-17T10:34:38.071Z" ,
                                                  </p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  <p>"Status":</p>
                                                  <p>"string" ,</p>
                                                </div>
                                                <p>{"}"}</p>
                                              </>
                                            </div>
                                          </div>
                                        </div>
                                        <p className="criteria-text ps-3">
                                          Enable seamless data exchange with
                                          other systems or applications through
                                          APIs.
                                        </p>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </>
                              )}
                              <Form.Check
                                type="radio"
                                id="default-radio2"
                                label="Embedded HTML"
                                name="output"
                                checked={
                                  outputSelection === "html" ? true : false
                                }
                                onChange={() => {
                                  handleOutputRadiochange("html");
                                }}
                              />
                              {outputSelection === "html" && (
                                <>
                                  <Form.Group className="form-group form-group-position">
                                    <Form.Control
                                      as="textarea"
                                      disabled
                                      value='<iframe name="i_frame" src="http://url.here" style="border: 0pt none ; left: -473px; top: -325px; position: absolute; width: 1318px; height: 608px;" scrolling="no"></iframe>'
                                      rows={3}
                                      placeholder="HTML"
                                      className="common-input"
                                      ref={textareaRef}
                                    />
                                    <img
                                      src={copyIcon}
                                      alt="copyIcon"
                                      onClick={handleCopyClick}
                                    />
                                  </Form.Group>
                                  <p className="criteria-text">
                                    Embed interactive reports and visuals
                                    directly into customer portals or websites
                                    using HTML integration.
                                  </p>
                                </>
                              )}
                              <Form.Check
                                type="radio"
                                id="default-radio6"
                                label="Web Hook"
                                name="output"
                                checked={
                                  outputSelection === "webHook" ? true : false
                                }
                                onChange={() => {
                                  handleOutputRadiochange("webHook");
                                }}
                              />
                              {outputSelection === "webHook" && (
                                <>
                                  <Form.Group className="form-group">
                                    <Form.Control
                                      placeholder="https://"
                                      className="common-input"
                                    />
                                  </Form.Group>
                                  <p className="criteria-text">
                                    Configure WebHooks to trigger notifications
                                    and updates in external systems based on
                                    specific events or thresholds.
                                  </p>
                                </>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <div className="d-flex align-items-center justify-content-end gap-2 mt20">
                  <button className="grey-btn w-auto">Cancel</button>
                  <button className="blue-btn w-auto">Submit</button>
                </div>
              </Col>
              <Col xl={5}>
                {/* <div className="project-view-summary-sec-main-wrapper"> */}
                <div className="project-view-summary-sec-main">
                  <div className="summary-title">
                    <h3>Summary</h3>
                  </div>
                  <div className="summary-body">
                    <div className="mb20">
                      <p>
                        Our project configuration offers a comprehensive
                        solution tailored to optimize hotel revenue management.
                      </p>
                      <br />
                      <p>
                        Through robust features like Revenue Insights, Booking
                        Analytics, and Guest Segmentation, we enable precise
                        decision-making to maximize occupancy and profitability.
                        Customers benefit from versatile output options
                        including Email notifications, API integrations for
                        seamless data exchange, Embedded HTML for real-time
                        reporting, and WebHook alerts for proactive monitoring.
                      </p>
                    </div>
                    <div>
                      <p>
                        This integrated approach ensures efficient communication
                        and actionable insights, empowering stakeholders to
                        streamline operations, enhance guest satisfaction, and
                        achieve sustained growth. With customizable
                        configurations and intuitive interfaces, our solution
                        equips hoteliers with the tools needed to thrive in a
                        competitive hospitality market, driving strategic
                        success and operational excellence.
                      </p>
                    </div>
                  </div>
                </div>

                <CostSummarySection />
                <UpcomingSchedules />
                {/* </div> */}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default ProjectView;
